import {
  Mapping,
  ModelConceptAttribute,
  ModelConceptAttributeData,
} from 'src/containers/ProjectDiagram/types/data';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { isMapping } from 'src/containers/ProjectDiagram/utils/data';
import { addMappingField } from 'src/containers/ProjectDiagram/utils/mapping/addMappingField';
import { removeMappingField } from 'src/containers/ProjectDiagram/utils/mapping/removeMappingField';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateModelAttributeIris =
  (prevIri: string, newIri: string) => (model: Model) => {
    model.linkDataArray
      .filter((data): data is Mapping => isMapping(data))
      .forEach(({ key, fields }) => {
        Object.entries(fields).forEach(([fieldId, { targets }]) => {
          targets
            .filter((target) => target === prevIri)
            .forEach(() => {
              removeMappingField({ key, fieldId, attributeIri: prevIri })(
                model
              );
              addMappingField({ key, fieldId, attributeIri: newIri })(model);
            });
        });
      });

    const getAttributeData = (
      data: Record<string, ModelConceptAttributeData>
    ) =>
      Object.entries(data).reduce<Record<string, ModelConceptAttributeData>>(
        (acc, [prevDataIri, prevData]) => {
          const dataIri = prevDataIri === prevIri ? newIri : prevDataIri;
          acc[dataIri] = { ...prevData, value: dataIri };
          return acc;
        },
        {}
      );

    const attributesByIri = Object.entries(
      model.modelData.attributesByIri
    ).reduce<Record<string, ModelConceptAttribute>>(
      (acc, [prevAttributeIri, prevAttribute]) => {
        const attributeIri =
          prevAttributeIri === prevIri ? newIri : prevAttributeIri;

        acc[attributeIri] = {
          ...prevAttribute,
          value: attributeIri,
          domains: getAttributeData(prevAttribute.domains),
          ranges: getAttributeData(prevAttribute.ranges),
        };

        return acc;
      },
      {}
    );

    setDataProperty<ModelData>(model)(
      model.modelData,
      'attributesByIri',
      attributesByIri
    );
  };
